import { render, staticRenderFns } from "./AsignacionOpexCapexIndex.vue?vue&type=template&id=805fb3ca"
import script from "./AsignacionOpexCapexIndex.vue?vue&type=script&lang=js"
export * from "./AsignacionOpexCapexIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports